import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';
import { ShieldCheck, Lock } from 'lucide-react';

export default function AdminLoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { loginAdmin } = useAuth();
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post('/auth/admin/login', { email, password });
            loginAdmin(data.token, data.admin);
            toast.success('Welcome, admin');
            navigate('/admin');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'Invalid credentials');
        } finally { setLoading(false); }
    };

    return (
        <PublicLayout>
            <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
                <Card className="max-w-md w-full p-6 sm:p-8">
                    <div className="flex items-center gap-2 mb-1">
                        <div className="h-10 w-10 rounded-lg bg-[#0E2A47] text-white flex items-center justify-center"><Lock className="h-5 w-5" /></div>
                        <div>
                            <div className="font-display font-semibold text-lg">Admin Console</div>
                            <div className="text-xs text-muted-foreground">Restricted access. Staff only.</div>
                        </div>
                    </div>
                    <div className="mt-4 flex items-center gap-2 text-[12px] text-muted-foreground">
                        <ShieldCheck className="h-3.5 w-3.5" /> Sessions are short-lived. Sign in to continue.
                    </div>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" data-testid="admin-login-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password">Password</Label>
                            <Input id="password" data-testid="admin-login-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
                        </div>
                        <Button type="submit" disabled={loading} className="w-full bg-[#0E2A47] hover:bg-[#0B223A]" data-testid="admin-login-submit-button">{loading ? 'Signing in...' : 'Sign in'}</Button>
                    </form>
                    <div className="mt-4 text-center text-sm">
                        <Link to="/forgot-password?role=admin" className="text-muted-foreground hover:text-foreground hover:underline" data-testid="admin-forgot-password-link">Forgot password?</Link>
                    </div>
                </Card>
            </div>
        </PublicLayout>
    );
}
